import axios from "@/plugins/axios";

let url = "/api/v1/me/dshop/orders";

export const orders = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    // put(data){
    //     return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    // },
    cancel(data){
        return axios.put(`${url}/${data._id}/cancel`, data).then(result => result.data);
    }
}
